module.exports = __webpack_public_path__ + "static/img/card_2_13.91d2782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/card_2_13.png
// module id = c7F1
// module chunks = 0